<template>
  <v-row>
    <!-- <v-col
      cols="12"
      class="d-flex align-baseline"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
    >
      <label class="title-label"
        >Start Date*
        <tip-icon>
          Select the date of the volunteer opportunity. If this is a "Runs
          until" need. Select the final date of the need.
        </tip-icon>
      </label>
      <v-menu
        v-model="date_picker_start"
        :close-on-content-click="false"
        :return-value.sync="startDate"
        transition="scale-transition"
        offset-y
        min-width="auto"
        :top="$vuetify.breakpoint.xs"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="need.start_date"
            label="MM/DD/YYYY"
            :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
            solo
            flat
            outlined
            dense
            v-bind="attrs"
            v-on="on"
            autocomplete="off"
          />
        </template>
        <v-date-picker
          v-model="startDate"
          no-title
          scrollable
          :min="new Date().toISOString().substr(0, 10)"
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="date_picker_start = false">
            Cancel
          </v-btn>
          <v-btn text color="primary" @click="onSaveStartDate(startDate)">
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
    </v-col> -->
    <v-col
      cols="12"
      class="d-flex align-baseline"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="hours"
    >
      <label class="title-label"
        >Hours*
        <tip-icon>
          Enter the number of hours the volunteer is expected to work.<br />
          This number is used by your volunteer check-in feature.
          <br />For multi-date needs, Enter the average number of hours expected
          each day.
        </tip-icon>
      </label>
      <v-text-field
        v-model="need.hours"
        label="Example: 4 or 3.5"
        :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
        solo
        flat
        outlined
        dense
        :min="1"
        type="number"
        :error-messages="hoursMessage"
        @input="onChange"
      />
    </v-col>
    <v-col
      cols="12"
      class="d-flex align-baseline"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="hours_description"
    >
      <label class="title-label"
        >Hours Description*
        <tip-icon>
          Let the volunteer know when the need is scheduled to start and end.
        </tip-icon>
      </label>
      <v-text-field
        v-model="need.hours_description"
        label="Example: 9am - 5pm"
        :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
        solo
        flat
        outlined
        dense
        :error-messages="hoursDescriptionMessage"
      />
    </v-col>
    <v-col
      cols="12"
      class="d-flex align-baseline"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="capacity"
    >
      <label class="title-label"
        >Capacity*
        <tip-icon>
          Enter the number of volunteer spots available.
        </tip-icon>
      </label>
      <v-text-field
        v-model="need.capacity"
        label="Example: 30"
        :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
        solo
        flat
        outlined
        dense
        :min="1"
        type="number"
        :error-messages="capacityMessage"
        @input="onCapacityInput"
      />
    </v-col>
    <!-- <v-col
      cols="12"
      class="d-flex align-baseline"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="registration_closed_date"
    >
      <label class="title-label"
        >Registration Closed Date*
        <tip-icon>
          Registration will close at midnight on this date. Volunteers can
          register before this date, but not on it.
        </tip-icon>
      </label>
      <v-menu
        v-model="date_picker_closed_date"
        :close-on-content-click="false"
        :return-value.sync="closedDate"
        transition="scale-transition"
        offset-y
        min-width="auto"
        :top="$vuetify.breakpoint.xs"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="need.registration_closed_date"
            label="MM/DD/YYYY"
            :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
            solo
            flat
            outlined
            dense
            v-bind="attrs"
            v-on="on"
            autocomplete="off"
            :error-messages="registrationClosedDateMessage"
          />
        </template>
        <v-date-picker v-model="closedDate" no-title scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="date_picker_closed_date = false">
            Cancel
          </v-btn>
          <v-btn text color="primary" @click="onSaveClosedDate(closedDate)">
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
    </v-col> -->
    <v-col
      cols="12"
      class="align-baseline d-flex"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="start_date"
    >
      <label class="title-label"
        >Start Date*
        <tip-icon>
          Select the date when the need is scheduled to start.
        </tip-icon>
      </label>
      <v-menu
        v-model="startDateMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="formattedStartDate"
            label="Select Start Date"
            readonly
            solo
            flat
            outlined
            dense
            v-bind="attrs"
            v-on="on"
            :error-messages="startDateErrorMessage"
            :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
          />
        </template>
        <v-date-picker
    v-model="need.start_date"
    :min="new Date().toISOString().substr(0, 10)"
    @input="onStartDateChange"
        ></v-date-picker>
      </v-menu>
    </v-col>
    <!-- <v-col
      cols="12"
      class="d-flex align-baseline"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
    >
      <label class="title-label"
        >End Date*
        <tip-icon>
          Select the date of the volunteer opportunity. If this is a "Runs
          until" need. Select the final date of the need.
        </tip-icon>
      </label>
      <v-menu
        v-model="date_picker"
        :close-on-content-click="false"
        :return-value.sync="endDate"
        transition="scale-transition"
        offset-y
        min-width="auto"
        :top="$vuetify.breakpoint.xs"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="need.end_date"
            label="MM/DD/YYYY"
            :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
            solo
            flat
            outlined
            dense
            v-bind="attrs"
            v-on="on"
            autocomplete="off"
          />
        </template>
        <v-date-picker
          v-model="endDate"
          no-title
          scrollable
          :min="new Date().toISOString().substr(0, 10)"
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="date_picker = false">
            Cancel
          </v-btn>
          <v-btn text color="primary" @click="onSaveEndDate(endDate)">
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
    </v-col> -->
    <v-col
      cols="12"
      class="align-baseline d-flex"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="end_date"
    >
      <label class="title-label"
        >End Date*
        <tip-icon>
          Select the date when the need is scheduled to end.
        </tip-icon>
      </label>
      <v-menu
        v-model="endDateMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="formattedEndDate"
            label="Select End Date"
            readonly
            solo
            flat
            outlined
            dense
            v-bind="attrs"
            v-on="on"
            :error-messages="endDateErrorMessage"
            :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
          />
        </template>
        <v-date-picker
          v-model="need.end_date"
          :min="endDateMinimum"
          @input="endDateMenu = false"
        ></v-date-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>
<script>
import TipIcon from "@/components/common/TipIcon.vue";
export default {
  components: { TipIcon },
  props: {
    need: Object,
    hoursMessage: String,
    capacityMessage: String,
    startDateErrorMessage: String,
    hoursDescriptionMessage: String,
    endDateErrorMessage: String,
    registrationClosedDateMessage: String,
    onChange: Function
  },
  data() {
    return {
      date_picker_start: false,
      date_picker: false,
      startDate: null,
      endDate: null,
      date_picker_closed_date: false,
      closedDate: null,
      startDateMenu: false,
      endDateMenu: false
    };
  },
  computed: {
    formattedStartDate() {
      // if (!this.need.start_date) return "";
      // const date = new Date(this.need.start_date);
      // const month = String(date.getMonth() + 1).padStart(2, "0");
      // const day = String(date.getDate()).padStart(2, "0");
      // const year = date.getFullYear();
      // return `${month}/${day}/${year}`;
      if (!this.need.start_date) return "";
      const [year, month, day] = this.need.start_date.split("-");
      return `${month}/${day}/${year}`;
    },
    formattedEndDate() {
      // if (!this.need.end_date) return "";
      // const date = new Date(this.need.end_date);
      // const month = String(date.getMonth() + 1).padStart(2, "0");
      // const day = String(date.getDate()).padStart(2, "0");
      // const year = date.getFullYear();
      // return `${month}/${day}/${year}`;
      if (!this.need.end_date) return "";
      const [year, month, day] = this.need.end_date.split("-");
      return `${month}/${day}/${year}`;
    },

      endDateMinimum() {
    // If start date is selected, use that as minimum for end date
    // Otherwise, use today as minimum
    if (this.need.start_date) {
      return this.need.start_date;
    }
    return new Date().toISOString().substr(0, 10);
  }
  },
  methods: {
    onCapacityInput(value) {
      const numericValue = value.replace(/[^0-9]/g, "");
      if (numericValue === "" || Number(numericValue) < 1) {
        this.need.capacity = 1;
      } else {
        this.need.capacity = Number(numericValue);
      }
    },
    changeDateFormat(dateStr) {
      return `${dateStr.substring(5, 7)}/${dateStr.substring(
        8,
        10
      )}/${dateStr.substring(0, 4)}`;
    },
          onStartDateChange() {
    this.startDateMenu = false;
    
    // If end date is selected and it's before the new start date, clear it
    if (this.need.end_date && this.need.start_date && this.need.end_date < this.need.start_date) {
      this.need.end_date = null;
    }
  },
    onSaveStartDate(dateStr) {
      this.need.start_date = this.changeDateFormat(dateStr);
      this.date_picker_start = false;
    },
    onSaveEndDate(dateStr) {
      this.need.end_date = this.changeDateFormat(dateStr);
      this.date_picker = false;
    },
    onSaveClosedDate(dateStr) {
      this.need.registration_closed_date = this.changeDateFormat(dateStr);
      this.date_picker_closed_date = false;
    }
  },
  mounted() {
    // Do not auto-set the start date, let user pick it
  }
};
</script>
<style scoped>
.title-label {
  width: 200px;
}
</style>
